/*!
 * Copyright (c) 2023 Bluemate B.V.
 */

@use '../../../../../style/common-variables' as commons;

.enable-two-factor {
  @include commons.backgroundShadow2;
  background-color: white;
  width: 30rem;
  max-width: 100vw;
  color: commons.$color-blue-text;

  .header-container,
  .body-container,
  .footer-container {
    padding: 1rem;
  }

  .header-container {
    border-bottom: 1px solid commons.$color-gray-7;
  }

  .body-container {
    position: relative;
    display: grid;
    grid-template-columns: auto;
    justify-items: center;
    grid-row-gap: 0.5rem;
    text-align: center;

    .qr {
      height: 100px;
      width: 100px;
      position: relative;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
